import { PageInitializedEvent } from '../../event'

export function handlePageInitializedEvent(event: PageInitializedEvent): void {
  pageInitializedEvent.sendToGTM(pageInitializedEvent.convertToGTMEvent(event))
}

const pageInitializedEvent = {
  convertToGTMEvent: (event: PageInitializedEvent): PageInitializedEventForGTM => {

    const userInfo = event.user
    const usableUserInfo: UserInfoLoggedIn | UserInfoNotLoggedIn = userInfo ? {
      id: userInfo.id,
      short_id: userInfo.shortid,
    } : {
      id: null,
      short_id: null,
    }

    const url = new URL(event.url)
    const path = url.pathname
    const hash = url.hash ? url.hash : null
    const query: Record<string, string> = {}
    url.searchParams.forEach((value, key) => {
      query[key] = value
    })

    return {
      event: 'page-initialized',
      url: {
        full: event.url,
        path,
        hash,
        query: Object.freeze(query),
      },
      user: usableUserInfo,
      initialized_at: event.initializedAt.toISOString(),
    }
  },
  sendToGTM(event: PageInitializedEventForGTM): void {
    window.dataLayer.push(event)
  },
} as const

/**
 * GTMへ送信されるイベント形式
 */
interface PageInitializedEventForGTM {
  /** イベント名 */
  readonly event: 'page-initialized'
  /** イベント発生URL */
  readonly url: Readonly<{
    /** 初期化完了したページのURL全体  */
    full: string
    /** 初期化完了したページのパス */
    path: string
    /** hashが付与されていない場合は null */
    hash: string | null,
    /** クエリ情報 */
    query: Readonly<Record<string, string>>
  }>,
  /** ユーザー情報 */
  readonly user: Readonly<UserInfoLoggedIn | UserInfoNotLoggedIn>,
  /** 初期化完了した日時 */
  readonly initialized_at: string
}
interface UserInfoNotLoggedIn {
  /** 未ログインの場合はnull */
  readonly id: null
  /** 未ログインの場合はnull */
  readonly short_id: null
}
interface UserInfoLoggedIn {
  /** アクセスユーザーのID */
  readonly id: string
  /** アクセスユーザーのshort id */
  readonly short_id: string
}
